import { render, staticRenderFns } from "./ContainerTypeModal.vue?vue&type=template&id=850b0ffe"
import script from "./ContainerTypeModal.vue?vue&type=script&lang=js"
export * from "./ContainerTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports